/**
 * Garde-fous de navigation déclarative.
 *
 * Un composant `<Navigate>` est ré-évalué à CHAQUE rendu. Si la cible est la
 * page déjà affichée, chaque commit de navigation provoque un nouveau rendu,
 * qui redéclenche la navigation : boucle infinie côté routeur
 * (React error #185 « Maximum update depth exceeded », pile
 * `navigate → buildAndCommitLocation → commitLocation → load`).
 *
 * Ces helpers sont purs et testables : ils décident si une redirection
 * déclarative doit réellement partir.
 */

/** Normalise un chemin : sans slash final, sans query ni hash. */
export function normalizePath(path: string): string {
  const withoutHash = (path ?? "").split("#")[0];
  const withoutQuery = withoutHash.split("?")[0];
  if (!withoutQuery) return "/";
  const trimmed = withoutQuery.replace(/\/+$/, "");
  return trimmed === "" ? "/" : trimmed;
}

/**
 * `true` seulement si la redirection change réellement de page.
 * Rediriger vers la page courante est un no-op qui boucle.
 */
export function shouldNavigateTo(currentPath: string, targetPath: string): boolean {
  if (!targetPath) return false;
  return normalizePath(currentPath) !== normalizePath(targetPath);
}
